import { render } from "./ReportKPICards.vue?vue&type=template&id=a65f23d8&scoped=true"
import script from "./ReportKPICards.vue?vue&type=script&lang=js"
export * from "./ReportKPICards.vue?vue&type=script&lang=js"

import "./ReportKPICards.vue?vue&type=style&index=0&id=a65f23d8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a65f23d8"]])

export default __exports__